/* eslint-disable no-else-return */
/* eslint-disable no-unused-vars */

import React, {  useState } from 'react';
import { symbolPriceFormatter } from '~/helpers/price';
import { color as colorAssets } from '~/assets/styles/colors';

import {  Card, CardBody,  Container,  Row, Tooltip } from 'reactstrap';
import { Text } from 'recharts';
import { LoaderMini } from '~/components/Loaders';
import { DivMontante, FlexMontante, Info, TextMontante, TitleMontante, TitleSecondValue } from './styles';



function CardTotalizador({value, title, subtitle, loading, color, borderColor='', textColor, idTooltip = "", tooltipText="", secondValue= "",
	secondText= ""}) {
	const [tooltipOpen, setTooltipOpen] = useState(false);
	const toggle = () => setTooltipOpen(!tooltipOpen);


	return (
		<Container>
			<Card
				style={{
					minHeight: '100%',
					marginBottom: 0,
					backgroundColor: color,
					border: `2px solid ${borderColor || color}`,
					borderRadius: '0px 15px 15px 15px',
				}}>
				<CardBody>
					<Row style={{
						paddingLeft: "20px",
						paddingRight: "20px",
						justifyContent: "space-between",
					}}>
						<TitleMontante>
							{ title }
							{idTooltip &&
								<>
									<Info
										id={idTooltip}
										onClick={toggle}
										/>
									<Tooltip
										placement="top"
										isOpen={tooltipOpen}
										target={idTooltip}
										toggle={toggle}
									>
										<p style={{fontSize: "13px", color: color.red}}>{tooltipText}</p>
									</Tooltip>
								</>
							}
						</TitleMontante>
						<TitleMontante>
							{ subtitle }
						</TitleMontante>
					</Row>

					<DivMontante>
						{ loading || value === undefined || value === null ? (
							<LoaderMini />
						) : (
							<FlexMontante>
								<TextMontante>
									<Text style={{color: textColor}}>
										{value === '--' ? value : symbolPriceFormatter(value)}
									</Text>
								</TextMontante>
							</FlexMontante>
						)}
					</DivMontante>
					<Row style={{
							paddingLeft: "20px",
							paddingRight: "20px",
							justifyContent: "space-between",
						}}>
					{ secondText.length > 0 && (
						<>
							<TitleMontante>
								{ secondText }
							</TitleMontante>
							<TitleSecondValue>
								{ secondValue ? secondValue.toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'}) : 'R$0,00' }
							</TitleSecondValue>
						</>
					)}
					</Row>
				</CardBody>
			</Card>
		</Container>
	);
}

export default CardTotalizador;
